import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    true: {
        id: 'true',
        defaultMessage: 'True',
    },
    false: {
        id: 'false',
        defaultMessage: 'False',
    },
    yes: {
        id: 'yes',
        defaultMessage: 'Yes',
    },
    no: {
        id: 'no',
        defaultMessage: 'No',
    },
    credit: {
        id: 'credit',
        defaultMessage: 'Credit',
    },
    debit: {
        id: 'debit',
        defaultMessage: 'Debit',
    },
    edit: {
        id: 'edit',
        defaultMessage: 'Edit',
    },
    add: {
        id: 'add',
        defaultMessage: 'Add',
    },
    save: {
        id: 'save',
        defaultMessage: 'Save',
    },
    delete: {
        id: 'delete',
        defaultMessage: 'Delete',
    },
    back: {
        id: 'back',
        defaultMessage: 'Back',
    },
    loading: {
        id: 'loading',
        defaultMessage: 'Loading...',
    },
    filter: {
        id: 'filter',
        defaultMessage: 'Filter',
    },
    close: {
        id: 'close',
        defaultMessage: 'Close',
    },
    cancel: {
        id: 'cancel',
        defaultMessage: 'Cancel',
    },
    active: {
        id: 'active',
        defaultMessage: 'Active',
    },
    inactive: {
        id: 'inactive',
        defaultMessage: 'Inactive',
    },
    viewAll: {
        id: 'viewAll',
        defaultMessage: 'View All',
    },
    from: {
        id: 'from',
        defaultMessage: 'From',
    },
    to: {
        id: 'to',
        defaultMessage: 'To',
    },
    reset: {
        id: 'reset',
        defaultMessage: 'Reset',
    },
    apply: {
        id: 'apply',
        defaultMessage: 'Apply',
    },
    done: {
        id: 'done',
        defaultMessage: 'Done',
    },
    submit: {
        id: 'submit',
        defaultMessage: 'Submit',
    },
    enabled: {
        id: 'enabled',
        defaultMessage: 'Enabled',
    },
    disabled: {
        id: 'disabled',
        defaultMessage: 'Disabled',
    },
    account: {
        id: 'account',
        defaultMessage: 'Account',
    },
    card: {
        id: 'card',
        defaultMessage: 'Card',
    },
    cards: {
        id: 'cards',
        defaultMessage: 'Cards',
    },
    customer: {
        id: 'customer',
        defaultMessage: 'Customer',
    },
    next: {
        id: 'next',
        defaultMessage: 'Next',
    },
    previous: {
        id: 'previous',
        defaultMessage: 'Previous',
    },
});

export default enumMessages;
